import React from 'react';
import "./index.css"
import _defaultImg from '../../../images/dashboard/noticeBoard-not1.png';
import _defaultImg2 from '../../../images/dashboard/noticeBoard-not2.png';
import { BsyUtils } from "../../../utils/Utils";
import _ from 'lodash';
class BsyDashNoticeBoard extends React.Component {
   
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    componentDidMount() {
        if (this.props.noticeBoard.styleType === "two" || this.props.noticeBoard.styleType === "one") {
            this.props?.onRefreshChars?.();
        }
    }
    setListData = (data) => {
        let list = []
        if (this.props.noticeBoard.styleType === 'two') {
            list = data.filter((item, key) => {
                return key <= 2
            })
        } else {
            list = data
        }
        return list.map((item, key) => {
            return <li key={key} onClick={() => {
                this.checkItemFn(item)
            }}>
                <div class="left-noot"><i className="icon-dian"></i><span class="title">{item.title || item.link}</span></div>
                {
                    this.props.noticeBoard.styleType === "one" && <div class="time">{item.date && BsyUtils.date2Str(new Date(item.date), "yyyy-MM-dd")}</div>
                }
            </li>
        })
    }
    checkMorenFn = () => {
        if (this.props.noticeBoard.titleLinkType === "internalPage" && !_.isEmpty(this.props.noticeBoard.titleModelFromData)) {
            window.open(window.FX.CONST.QN_BUCKET.SITE + 'team/app/' +
                this.props.noticeBoard.titleModelFromData.appid +
                "/" + (this.props.noticeBoard.titleModelFromData.type || "form") + "/" +
                this.props.noticeBoard.titleModelFromData.formid);
        }
        if (this.props.noticeBoard.titleLinkType === "externalLink" && !_.isEmpty(this.props.noticeBoard.titleModelink)) {
            window.open(this.props.noticeBoard.titleModelink);
        }
    }
    toSettingNotice = () => {
        this.props.emitSettingNotice()
    }
    checkItemFn = (item) => {
        if (this.props.noticeBoard.dataSource === "dynamicDataSource") {
            window.open(item.link);
            return
        }

        if (item.linkType === "internalPage" && !_.isEmpty(item.interModel)) {
            window.open(window.FX.CONST.QN_BUCKET.SITE + 'team/app/' +
                item.interModel.appid +
                "/" + (item.interModel.type || "form") + "/" +
                item.interModel.formid);
        }
        else {
            !_.isEmpty(item.link) && window.open(item.link);
        }

    }
    checkImgFn = () => {
        if (this.props.noticeBoard.imgLinkType === "internalPage" && !_.isEmpty(this.props.noticeBoard.imgModelFromData)) {
            window.open(window.FX.CONST.QN_BUCKET.SITE + 'team/app/' +
                this.props.noticeBoard.imgModelFromData.appid +
                "/" + (this.props.noticeBoard.imgModelFromData.type || "form") + "/" +
                this.props.noticeBoard.imgModelFromData.formid);
        }
        if (this.props.noticeBoard.imgLinkType === "externalLink" && !_.isEmpty(this.props.noticeBoard.imgModelink)) {
            window.open(this.props.noticeBoard.imgModelink);
        }
    }
    render() {
        return <div className={'notice-board-page ' + this.props.noticeBoard.styleType + " " + this.props.mode + " " + (((this.props.noticeBoard.isShowTitle || this.props.noticeBoard.isShowMoreTitle) || this.props.mode !== 'visit') ? "" : "no-title-notice-board-page")}>
            {
                this.props.noticeBoard.isShowMoreTitle && <div className='more' onClick={() => { this.checkMorenFn() }}><span>{React.language("dashboard.see.more")}</span><i className='icon-subform-next'></i></div>
            }

            {
                this.props.noticeBoard.styleType && <>  <div className={'left t-list' + (this.props.noticeBoard.dataSource === 'dynamicDataSource' ? this.props.noticeBoard.noticeListDynamic.length : this.props.noticeBoard.noticeListStatic.length)}>
                    {
                        _.isEmpty(this.props.noticeBoard.imgFile) && <div className='default'>

                            <img src={this.props.noticeBoard.styleType === 'one' ? _defaultImg2 : _defaultImg} alt='' />
                        </div>
                    }
                    {
                        !_.isEmpty(this.props.noticeBoard.imgFile) && <div className={this.props.noticeBoard.coverStyle + ' img-box'} style={{
                            backgroundImage: "url(" + (this.props.noticeBoard.imgFile.previewUrl ||  BsyUtils.getfiledownloadURL(this.props.noticeBoard.imgFile, {})) + ")"
                        }} onClick={() => {
                            this.checkImgFn()
                        }}>
                            <img className='t-visibility-img' src={this.props.noticeBoard.styleType === 'one' ? _defaultImg2 : _defaultImg} alt='' />
                        </div>
                    }
                </div>
                    <div className='rigth'>
                        {
                            this.props.noticeBoard.dataSource === 'dynamicDataSource' && this.props.noticeBoard.noticeListDynamic.length === 0 && <div className='no-data'><span>暂无配置数据</span></div>
                        }
                        {
                            this.props.noticeBoard.dataSource === 'staticDataSource' && this.props.noticeBoard.noticeListStatic.length === 0 && <div className='no-data'><span>暂无配置数据</span></div>
                        }
                        {
                            this.props.noticeBoard.dataSource === 'dynamicDataSource' && this.props.noticeBoard.noticeListDynamic.length > 0 && <ul className={'t-list' + this.props.noticeBoard.noticeListDynamic.length}>{this.setListData(this.props.noticeBoard.noticeListDynamic)}</ul>
                        }
                        {
                            this.props.noticeBoard.dataSource === 'staticDataSource' && this.props.noticeBoard.noticeListStatic.length > 0 && <ul className={'t-list' + this.props.noticeBoard.noticeListDynamic.length}>{this.setListData(this.props.noticeBoard.noticeListStatic)}</ul>
                        }
                    </div></>
            }
            {
                (_.isEmpty(this.props.noticeBoard) || _.isEmpty(this.props.noticeBoard.styleType)) && <div className='notice-no-data'><span className='text'>{React.language("workbench.noticeBoard.no")}</span>
                
                {this.props.designMode === "computer" && <button onMouseDown={this.toSettingNotice} className='t-setting'>{React.language("setting")}</button>}
                </div>
            }
        </div>;
    }
}



export default BsyDashNoticeBoard;